import { IAdvanceSearch } from '../../common/models/IAdvanceSearch';


export class SetAdvanceSearchData {
    static readonly type = '[AdvanceSearch] Set AdvanceSearch Data';

    constructor(public advanceSearch: IAdvanceSearch) {}
}

export class ClearAdvanceSearch {
    static readonly type = '[AdvanceSearch] Clear AdvanceSearch State';

    constructor() {}
}
